<template>

  <div class="card p-3">
    <div class="grid">

      <!-- Titulo Oficios -->
      <div class="col-9 xl:col-3 lg:col-3 md:col-4 sm:col-7 p-2 flex justify-content-end">
        <h5 class="p-2 mt-2 tablaTitle">
          <i class="fa-solid fa-bell-concierge fa-shake px-2"
            style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"></i>
          Recepción de oficios
        </h5>
      </div>
      <!-- Titulo Oficios -->

      <div class="col-3 xl:col-2 lg:col-7 md:col-8 sm:col-5 flex justify-content-start">
        <dialogAyudaRecepcionOficios />
      </div>

      <div class="col-0 xl:col-7 lg:col-7 md:col-0 sm:col-0 p-2"></div>

      <!-- Tabs -->
      <div class="col-12 p-2">
        <div class="card">

          <TabViewVue class="tabview-custom tabsTablas" :activeIndex="parseInt(selectedTab)">

            <!-- Tabla de Pendientes -->
            <TabPanelVue>
              <template #header>
                <!-- @click="getFichasRecepcionPendientesTabla" -->
                <div class="divTabs" >
                    <!-- Contador para oficios -->
                    <BadgeVue
                     :value="contadorOficiosPendientes"
                     class="titulosPestanasContador">
                    </BadgeVue>
                    <!-- Contador para oficios -->
                    <i class="fa-solid fa-bell fa-bounce px-2"
                      style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;">
                    </i>
                    <span>Oficios pendientes</span>
                </div>


              </template>

              <div class="card p-1">
                <DataTable
                  :value="fichasRecepcionPendientes"
                  responsiveLayout="scroll"
                  v-model:filters="filtersPendientes"
                  stripedRows
                  sortField="numeroOficio"
                  :sortOrder="-1"
                  :paginator="true"
                  :rows="10"
                  paginatorTemplate="CurrentPageReport  PrevPageLink PageLinks NextPageLink  RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]"
                  removableSort
                  dataKey="numeroOficio"
                  class="p-datatable-sm"
                  style="width: 100%">

                  <template #header>
                    <div class="grid">

                      <div class="col-12 p-1">
                        <div class="flex justify-content-center">
                          <span class="p-input-icon-left m-2">
                            <i class="pi pi-search" />
                            <InputTextV v-model="filtersPendientes['global'].value" placeholder="Buscar"
                              class="p-inputtext-sm" />
                          </span>
                        </div>
                      </div>

                    </div>

                  </template>

                  <template #empty>

                    <InlineMessageVue severity="info" class="border-dashed border-300">
                      No se encontraron resultados.
                    </InlineMessageVue>

                  </template>

                  <template #loading>
                    <InlineMessageVue severity="info" class="border-dashed border-300">
                      Cargando....
                    </InlineMessageVue>
                  </template>

                  <ColumnVue
                    v-for="col of columnasPendientes"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    :sortable="true"
                    :hidden="col.hidden"
                    class="border-dashed border-300 tablaOficiosData"
                  >
                  </ColumnVue>
                  <ColumnVue :exportable="false" style="width: 160px;text-align: center;" header="Prioridad" class="tablaOficiosData">
                    <template #body="slotProps">
                      <div>
                        <span class="">{{slotProps.data.prioridad == '' ? 'N/A' : slotProps.data.prioridad}}</span>
                      </div>
                    </template>
                  </ColumnVue>
                  <ColumnVue :exportable="false" style="width: 250px;text-align: center;" header="Nombre Asistente" class="tablaOficiosData">
                    <template #body="slotProps">
                      <div>
                        <span class="">{{slotProps.data.nombre_asistente == '' ? 'N/A' : slotProps.data.nombre_asistente}}</span>
                      </div>
                    </template>
                  </ColumnVue>
                  <ColumnVue :exportable="false" style="width: 18rem" header="Opciones" class="tablaOficiosData">
                    <template #body="slotProps">

                      <!-- #########################################################SIN ANEXO################################################################ -->
                      <!-- Oficios Enviado a Recepcion (Adjuntado) Estado 7 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 0"
                        icon="fa-solid fa-paper-plane fa-bounce" style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado7 w-full" label="Oficio recibido"
                        v-tooltip.top="'El remitente te ha enviado un oficio adjunto que debes contestar o turnar'"
                        :model="[
                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {

                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },


                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );
                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Oficios Enviado a Recepcion (Adjuntado) Estado 7 -->

                      <!-- Oficios Enviado a Recepcion (Creado) Estado 7 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 0"
                        icon="fa-regular fa-paper-plane fa-bounce" style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado7 w-full" label="Oficio recibido"
                        v-tooltip.top="'El remitente ha creado un oficio desde la plataforma y te lo ha enviado, debes contestar o turnar'"
                        :model="[
                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Oficios Enviado a Recepcion (Creado) Estado 7 -->

                      <!-- Oficios Contestados (Adjuntado) Estado 8 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 1"
                        icon="fa-solid fa-check-to-slot fa-bounce" style="--fa-animation-duration: 15s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado8 w-full" label="Oficio en proceso de contestación"
                        v-tooltip.top="'El oficio ha sido contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Oficios Contestados (Adjuntado) Estado 8 -->

                      <!-- Oficios Contestados (Creado) Estado 8 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 1"
                        icon="fa-solid fa-file-circle-check fa-bounce" style="--fa-animation-duration: 15s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado8 w-full" label="Oficio en proceso de contestación"
                        v-tooltip.top="'El oficio ha sido contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])


                        ]" />
                      <!-- Oficios Contestados (Creado) Estado 8 -->

                      <!-- ####################################### Turnados ################################################## -->

                      <!-- Oficios Enviado a Recepcion (Adjuntado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 0"
                        icon="fa-solid fa-paper-plane fa-bounce" style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10 w-full" label="Oficio recibido"
                        v-tooltip.top="'El remitente te ha enviado un oficio adjunto que debes contestar o turnar'"
                        :model="[
                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },


                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },

                        ]" /> -->
                      <!-- Oficios Enviado a Recepcion (Adjuntado) Estado 10 -->

                      <!-- Oficios Enviado a Recepcion (Creado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 0"
                        icon="fa-regular fa-paper-plane fa-bounce" style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10 w-full" label="Oficio recibido"
                        v-tooltip.top="'El remitente ha creado un oficio desde la plataforma y te lo ha enviado, debes contestar o turnar'"
                        :model="[
                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },

                        ]" /> -->
                      <!-- Oficios Enviado a Recepcion (Creado) Estado 10 -->

                      <!-- Oficios Contestados (Adjuntado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 1"
                        icon="fa-solid fa-check-to-slot fa-bounce" style="--fa-animation-duration: 15s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10 w-full" label="Oficio en proceso de contestación"
                        v-tooltip.top="'El oficio ha sido contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },

                        ]" /> -->
                      <!-- Oficios Contestados (Adjuntado) Estado 10 -->

                      <!-- Oficios Contestados (Creado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 1"
                        icon="fa-solid fa-file-circle-check fa-bounce" style="--fa-animation-duration: 15s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10 w-full" label="Oficio en proceso de contestación"
                        v-tooltip.top="'El oficio ha sido contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },


                        ]" /> -->
                      <!-- Oficios Contestados (Creado) Estado 10 -->

                      <!-- ####################################### Turnados ################################################## -->

                      <!-- #########################################################SIN ANEXO################################################################ -->

                      <!-- #########################################################CON ANEXO################################################################ -->
                      <!-- Oficios Enviado a Recepcion (Adjuntado) Estado 7 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 0"
                        icon="fa-solid fa-paper-plane fa-bounce" style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado7 w-full" label="Oficio recibido-"
                        v-tooltip.top="'El remitente te ha enviado un oficio adjunto que debes contestar o turnar'"
                        :model="[
                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },


                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        },
                        {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]" />
                      <!-- Oficios Enviado a Recepcion (Adjuntado) Estado 7 -->

                      <!-- Oficios Enviado a Recepcion (Creado) Estado 7 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 0"
                        icon="fa-regular fa-paper-plane fa-bounce" style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado7 w-full" label="Oficio recibido-"
                        v-tooltip.top="'El remitente ha creado un oficio desde la plataforma y te lo ha enviado, debes contestar o turnar'"
                        :model="[
                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        },
                        {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Oficios Enviado a Recepcion (Creado) Estado 7 -->

                      <!-- Oficios Contestados (Adjuntado) Estado 8 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 1"
                        icon="fa-solid fa-check-to-slot fa-bounce" style="--fa-animation-duration: 15s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado8 w-full" label="Oficio en proceso de contestación-"
                        v-tooltip.top="'El oficio ha sido contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },



                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        },
                        {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Oficios Contestados (Adjuntado) Estado 8 -->

                      <!-- Oficios Contestados (Creado) Estado 8 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 1"
                        icon="fa-solid fa-file-circle-check fa-bounce" style="--fa-animation-duration: 15s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado8 w-full" label="Oficio en proceso de contestación-"
                        v-tooltip.top="'El oficio ha sido contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },



                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        },
                        {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Oficios Contestados (Creado) Estado 8 -->

                      <!-- ####################################### Turnados ################################################## -->

                      <!-- Oficios Enviado a Recepcion (Adjuntado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 0"
                        icon="fa-solid fa-paper-plane fa-bounce" style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10 w-full" label="Oficio recibido-"
                        v-tooltip.top="'El remitente te ha enviado un oficio adjunto que debes contestar o turnar'"
                        :model="[
                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },


                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        }
                        ]" /> -->
                      <!-- Oficios Enviado a Recepcion (Adjuntado) Estado 10 -->

                      <!-- Oficios Enviado a Recepcion (Creado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 0"
                        icon="fa-regular fa-paper-plane fa-bounce" style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10 w-full" label="Oficio recibido-"
                        v-tooltip.top="'El remitente ha creado un oficio desde la plataforma y te lo ha enviado, debes contestar o turnar'"
                        :model="[
                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        }

                        ]" /> -->
                      <!-- Oficios Enviado a Recepcion (Creado) Estado 10 -->

                      <!-- Oficios Contestados (Adjuntado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 1"
                        icon="fa-solid fa-check-to-slot fa-bounce" style="--fa-animation-duration: 15s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10 w-full" label="Oficio en proceso de contestación-"
                        v-tooltip.top="'El oficio ha sido contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },



                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        }

                        ]" /> -->
                      <!-- Oficios Contestados (Adjuntado) Estado 10 -->

                      <!-- Oficios Contestados (Creado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 1"
                        icon="fa-solid fa-file-circle-check fa-bounce" style="--fa-animation-duration: 15s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10 w-full" label="Oficio en proceso de contestación-"
                        v-tooltip.top="'El oficio ha sido contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjunto',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestar(
                                'ContestarOficioRemitente',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },



                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        }

                        ]" /> -->
                      <!-- Oficios Contestados (Creado) Estado 10 -->

                      <!-- ####################################### Turnados ################################################## -->

                      <!-- #########################################################CON ANEXO################################################################ -->

                    </template>
                  </ColumnVue>
                </DataTable>
              </div>

            </TabPanelVue>
            <!-- Tabla de Pendientes -->

            <!-- Tabla de Atencion A -->
            <TabPanelVue>
              <template #header>
                <!-- @click="getFichasRecepcionAtencionATabla" -->
                <div class="divTabs" >
                    <!-- Contador para oficios -->
                    <BadgeVue
                     :value="contadorOficiosAtencion"
                     class="titulosPestanasContador">
                    </BadgeVue>
                    <!-- Contador para oficios -->
                    <i class="fa-solid fa-tag fa-bounce px-2"
                      style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;">
                    </i>
                    <span>Oficios con atención</span>
                </div>
              </template>

              <div class="card p-1">
                <DataTable
                  :value="fichasRecepcionAtencion"
                  responsiveLayout="scroll"
                  v-model:filters="filtersAtencionA"
                  stripedRows
                  sortField="numeroOficio"
                  :sortOrder="-1"
                  :paginator="true"
                  :rows="10"
                  paginatorTemplate="CurrentPageReport  PrevPageLink PageLinks NextPageLink  RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]" removableSort
                  dataKey="numeroOficio"
                  class="p-datatable-sm"
                  style="width: 100%">

                  <template #header>
                    <div class="grid">

                      <div class="col-12 p-1">
                        <div class="flex justify-content-center">
                          <span class="p-input-icon-left m-2">
                            <i class="pi pi-search" />
                            <InputTextV v-model="filtersAtencionA['global'].value" placeholder="Buscar"
                              class="p-inputtext-sm" />
                          </span>
                        </div>
                      </div>

                    </div>

                  </template>

                  <template #empty>

                    <InlineMessageVue severity="info" class="border-dashed border-300">
                      No se encontraron resultados.
                    </InlineMessageVue>

                  </template>

                  <template #loading>
                    <InlineMessageVue severity="info" class="border-dashed border-300">
                      Cargando....
                    </InlineMessageVue>
                  </template>

                  <ColumnVue v-for="col of columnasAtencion"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    :sortable="true"
                    :hidden="col.hidden" class="border-dashed border-300 tablaOficiosData">
                  </ColumnVue>
 <ColumnVue :exportable="false" style="width: 250px;text-align: center;" header="Nombre Asistente" class="tablaOficiosData">
                    <template #body="slotProps">
                      <div>
                        <span class="">{{slotProps.data.nombre_asistente == '' ? 'N/A' : slotProps.data.nombre_asistente}}</span>
                      </div>
                    </template>
                  </ColumnVue>
                  <ColumnVue :exportable="false" style="width: 18rem" header="Opciones" class="tablaOficiosData">
                    <template #body="slotProps">

                      <!-- #########################################################SIN ANEXO################################################################ -->
                      <!-- Oficios Atencion A (Adjuntado) Estado 7 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 0"
                        icon="fa-solid fa-tag fa-shake" style="--fa-animation-duration: 2.5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado7A w-full"
                        label="Oficio con atención a" v-tooltip.top="'Oficio con atención.'" :model="[

                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]" />
                      <!-- Oficios Atencion A (Adjuntado) Estado 7 -->

                      <!-- Oficios Atencion A (Creado) Estado 7 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 0"
                        icon="fa-solid fa-tags fa-shake" style="--fa-animation-duration: 2.5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado7A w-full" label="Oficio con atención"
                        v-tooltip.top="'Oficio con atención.'" :model="[

                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]" />
                      <!-- Oficios Atencion A (Creado) Estado 7 -->

                      <!-- Oficios Atencion A Contestados (Adjuntado) Estado 8 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 1"
                        icon="fa-solid fa-calendar-check fa-beat" style="--fa-animation-duration: 6s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado8A w-full"
                        label="Atención a. contestado nuevamente"
                        v-tooltip.top="'El oficio adjunto con atención, fue contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])


                        ]" />
                      <!-- Oficios Atencion A Contestados (Adjuntado) Estado 8 -->

                      <!-- Oficios Atencion A Contestados (Creado) Estado 8 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 1"
                        icon="fa-regular fa-calendar-check fa-beat" style="--fa-animation-duration: 6s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado8A w-full"
                        label="Atencion a. contestado nuevamente"
                        v-tooltip.top="'El oficio creado con atención, fue contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Oficios Atencion A Contestados (Creado) Estado 8 -->

                      <!-- ####################################### Turnados ################################################## -->

                      <!-- Oficios Atencion A (Adjuntado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 0"
                        icon="fa-solid fa-tag fa-shake" style="--fa-animation-duration: 2.5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10T w-full"
                        label="Oficio con atención a" v-tooltip.top="'Oficio con atención.'" :model="[

                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },

                        ]" /> -->
                      <!-- Oficios Atencion A (Adjuntado) Estado 10 -->

                      <!-- Oficios Atencion A (Creado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 0"
                        icon="fa-solid fa-tags fa-shake" style="--fa-animation-duration: 2.5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10T w-full" label="Oficio con atención"
                        v-tooltip.top="'Oficio con atención.'" :model="[

                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },

                        ]" /> -->
                      <!-- Oficios Atencion A (Creado) Estado 10 -->

                      <!-- Oficios Atencion A Contestados (Adjuntado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 1"
                        icon="fa-solid fa-calendar-check fa-beat" style="--fa-animation-duration: 6s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10T w-full"
                        label="Atención a. contestado nuevamente"
                        v-tooltip.top="'El oficio adjunto con atención, fue contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },



                        ]" /> -->
                      <!-- Oficios Atencion A Contestados (Adjuntado) Estado 10 -->

                      <!-- Oficios Atencion A Contestados (Creado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 0 && slotProps.data.respuesta == 1"
                        icon="fa-regular fa-calendar-check fa-beat" style="--fa-animation-duration: 6s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10T w-full"
                        label="Atencion a. contestado nuevamente"
                        v-tooltip.top="'El oficio creado con atención, fue contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },



                        ]" /> -->
                      <!-- Oficios Atencion A Contestados (Creado) Estado 10 -->

                      <!-- ####################################### Turnados ################################################## -->

                      <!-- #########################################################SIN ANEXO################################################################ -->

                      <!-- #########################################################CON ANEXO################################################################ -->
                      <!-- Oficios Atencion A (Adjuntado) Estado 7 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 0"
                        icon="fa-solid fa-tag fa-shake" style="--fa-animation-duration: 2.5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado7A w-full"
                        label="Oficio con atención a-" v-tooltip.top="'Oficio con atención.'" :model="[

                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        },
                        {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Oficios Atencion A (Adjuntado) Estado 7 -->

                      <!-- Oficios Atencion A (Creado) Estado 7 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 0"
                        icon="fa-solid fa-tags fa-shake" style="--fa-animation-duration: 2.5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado7A w-full" label="Oficio con atención-"
                        v-tooltip.top="'Oficio con atención.'" :model="[

                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        },
                        {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Oficios Atencion A (Creado) Estado 7 -->

                      <!-- Oficios Atencion A Contestados (Adjuntado) Estado 8 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 1"
                        icon="fa-solid fa-calendar-check fa-beat" style="--fa-animation-duration: 6s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado8A w-full"
                        label="Atención a. contestado nuevamente-"
                        v-tooltip.top="'El oficio adjunto con atención, fue contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },



                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        },
                        {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Oficios Atencion A Contestados (Adjuntado) Estado 8 -->

                      <!-- Oficios Atencion A Contestados (Creado) Estado 8 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 1"
                        icon="fa-regular fa-calendar-check fa-beat" style="--fa-animation-duration: 6s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado8A w-full"
                        label="Atencion a. contestado nuevamente-"
                        v-tooltip.top="'El oficio creado con atención, fue contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },



                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        },
                        {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Oficios Atencion A Contestados (Creado) Estado 8 -->

                      <!-- ####################################### Turnados ################################################## -->

                      <!-- Oficios Atencion A (Adjuntado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 0"
                        icon="fa-solid fa-tag fa-shake" style="--fa-animation-duration: 2.5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10T w-full"
                        label="Oficio con atención a-" v-tooltip.top="'Oficio con atención.'" :model="[

                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        }

                        ]" /> -->
                      <!-- Oficios Atencion A (Adjuntado) Estado 10 -->

                      <!-- Oficios Atencion A (Creado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 0"
                        icon="fa-solid fa-tags fa-shake" style="--fa-animation-duration: 2.5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10T w-full" label="Oficio con atención-"
                        v-tooltip.top="'Oficio con atención.'" :model="[

                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Turnar oficio',
                            icon: 'pi pi-arrow-right-arrow-left',
                            command: () => {
                              openDialogTurnar(
                                'TurnarOficio',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        }

                        ]" /> -->
                      <!-- Oficios Atencion A (Creado) Estado 10 -->

                      <!-- Oficios Atencion A Contestados (Adjuntado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 1"
                        icon="fa-solid fa-calendar-check fa-beat" style="--fa-animation-duration: 6s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10T w-full"
                        label="Atención a. contestado nuevamente-"
                        v-tooltip.top="'El oficio adjunto con atención, fue contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },



                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        }

                        ]" /> -->
                      <!-- Oficios Atencion A Contestados (Adjuntado) Estado 10 -->

                      <!-- Oficios Atencion A Contestados (Creado) Estado 10 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 1 && slotProps.data.respuesta == 1"
                        icon="fa-regular fa-calendar-check fa-beat" style="--fa-animation-duration: 6s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado10T w-full"
                        label="Atencion a. contestado nuevamente-"
                        v-tooltip.top="'El oficio creado con atención, fue contestado'" :model="[

                        {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente con oficio adjunto',
                            icon: 'pi pi-paperclip',
                            command: () => {
                              openDialogMFicha(
                                'ContestarAdjuntoA',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Contestar nuevamente creando un oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogContestarA(
                                'ContestarOficioAtencion',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Archivar oficio',
                            icon: 'pi pi-reply',
                            command: () => {
                              openDialogArchivar(
                                'ArchivarOficio',
                                slotProps.data
                              );
                            },
                          },



                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              downloadAnexo(slotProps.data);
                          },
                        }

                        ]" /> -->
                      <!-- Oficios Atencion A Contestados (Creado) Estado 10 -->

                      <!-- ####################################### Turnados ################################################## -->

                      <!-- #########################################################CON ANEXO################################################################ -->

                    </template>
                  </ColumnVue>
                </DataTable>
              </div>

            </TabPanelVue>
            <!-- Tabla de Atencion A -->

            <!-- Tabla de CCP -->
            <TabPanelVue>
              <template #header>
                <!--  @click="getFichasCCP" -->
                <div class="divTabs">
                    <!-- Contador para oficios -->
                    <BadgeVue
                     :value="contadorOficiosCCP"
                     class="titulosPestanasContador">
                    </BadgeVue>
                    <!-- Contador para oficios -->
                    <i class="fa-solid fa-check fa-bounce px-2"
                      style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"></i>
                    <span>Con copia para</span>
                </div>

              </template>

              <div class="card p-1">
                <DataTable
                  :value="VoBoyCcp"
                  responsiveLayout="scroll"
                  v-model:filters="filtersCCPAtencionOA" stripedRows
                  sortField="numeroOficio"
                  :sortOrder="-1"
                  :paginator="true"
                  :rows="10"
                  paginatorTemplate="CurrentPageReport  PrevPageLink PageLinks NextPageLink  RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]" removableSort
                  dataKey="numeroOficio"
                  class="p-datatable-sm"
                  style="width: 100%">

                  <template #header>
                    <div class="grid">

                      <div class="col-12 p-1">
                        <div class="flex justify-content-center">
                          <span class="p-input-icon-left m-2">
                            <i class="pi pi-search" />
                            <InputTextV v-model="filtersCCPAtencionOA['global'].value" placeholder="Buscar"
                              class="p-inputtext-sm" />
                          </span>
                        </div>
                      </div>

                    </div>

                  </template>

                  <template #empty>

                    <InlineMessageVue severity="info" class="border-dashed border-300">
                      No se encontraron resultados.
                    </InlineMessageVue>

                  </template>

                  <template #loading>
                    <InlineMessageVue severity="info" class="border-dashed border-300">
                      Cargando....
                    </InlineMessageVue>
                  </template>

                  <ColumnVue v-for="col of columns" :field="col.field" :header="col.header" :key="col.field"
                    :sortable="true" :hidden="col.hidden" class="border-dashed border-300 tablaOficiosData">
                  </ColumnVue>
                   <ColumnVue :exportable="false" style="width: 250px;text-align: center;" header="Nombre Asistente" class="tablaOficiosData">
                    <template #body="slotProps">
                      <div>
                        <span class="">{{slotProps.data.nombre_asistente == '' ? 'N/A' : slotProps.data.nombre_asistente}}</span>
                      </div>
                    </template>
                  </ColumnVue>

                  <ColumnVue :exportable="false" style="width: 18rem" header="Opciones" class="tablaOficiosData">
                    <template #body="slotProps">

                      <!-- Oficios para CCP (Adjuntado)  -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.statusVoBo == 0 && slotProps.data.vobo_ccp == 1"
                        icon="fa-solid fa-square-check fa-bounce" style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado16 w-full"
                        label="Oficio de conocimiento" v-tooltip.top="'Oficio de conocimiento adjunto'" :model="[

                          {
                            label: 'Ver oficio adjunto',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Oficios para CCP (Adjuntado)  -->

                      <!-- Oficios para CCP (Creado)  -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.statusVoBo == 0 && slotProps.data.vobo_ccp == 1"
                        icon="fa-regular fa-square-check fa-bounce" style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado16 w-full"
                        label="Oficio de conocimiento" v-tooltip.top="'Oficio de conocimiento creado'" :model="[

                          {
                            label: 'Ver oficio creado',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(typeUser === 2 || typeUser === 1 
                            ? [
                                {
                                  label: 'Asignar o reasignar asistentes al oficio',
                                  icon: 'pi pi-file',
                                  command: () => {
                                    console.log(slotProps.data)
                                    openDialogAsignarAsistente(
                                      'AsignarAsistente',
                                      slotProps.data,
                                    );

                                  },
                                },
                              ]
                            : []),
                            ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Oficios para CCP (Creado)  -->

                       <!-- Oficios para CCP (Adjuntado)  -->
                       <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1 && slotProps.data.statusVoBo == 0 && slotProps.data.vobo_ccp == 2"
                        icon="fa-solid fa-square-check fa-bounce" style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado16 w-full"
                        label="Oficio de conocimiento-" v-tooltip.top="'Oficio de conocimiento adjunto'" :model="[

                          {
                            label: 'Ver oficio adjunto',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Oficios para CCP (Adjuntado)  -->

                      <!-- Oficios para CCP (Creado)  -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2 && slotProps.data.statusVoBo == 0 && slotProps.data.vobo_ccp == 2"
                        icon="fa-regular fa-square-check fa-bounce" style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado16 w-full"
                        label="Oficio de conocimiento-" v-tooltip.top="'Oficio de conocimiento creado'" :model="[

                          {
                            label: 'Ver oficio creado',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Oficios para CCP (Creado)  -->

                    </template>
                  </ColumnVue>
                </DataTable>
              </div>

            </TabPanelVue>
            <!-- Tabla de CCP -->

            <!-- Tabla de atendidos -->
              <TabPanelVue>
              <template #header>
                <!--  @click="getFichasCCP" -->
                <div class="divTabs">
                    <!-- Contador para oficios -->
                    <BadgeVue
                     :value="contadorOficiosOA"
                     class="titulosPestanasContador">
                    </BadgeVue>
                    <!-- Contador para oficios -->
                    <i class="fa-solid fa-check fa-bounce px-2"
                      style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"></i>
                    <span>Oficios atendidos</span>
                </div>

              </template>

              <div class="card p-1">
                <DataTable
                  :value="oficiosAtencionOA"
                  responsiveLayout="scroll"
                  v-model:filters="filtersAtendidos" stripedRows
                  :globalFilterFields="['numeroOficio', 'fechaCreacion', 'fechaRecepcion', 'asunto',]"
                  sortField="numeroOficio"
                  :sortOrder="-1"
                  :paginator="true"
                  :rows="10"
                  paginatorTemplate="CurrentPageReport  PrevPageLink PageLinks NextPageLink  RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]" removableSort
                  dataKey="numeroOficio"
                  class="p-datatable-sm"
                  style="width: 100%">

                  <template #header>
                    <div class="grid">

                      <div class="col-12 p-1">
                        <div class="flex justify-content-center">
                          <span class="p-input-icon-left m-2">
                            <i class="pi pi-search" />
                            <InputTextV v-model="filtersAtendidos['global'].value" placeholder="Buscar"
                              class="p-inputtext-sm" />
                          </span>
                        </div>
                      </div>

                    </div>

                  </template>

                  <template #empty>

                    <InlineMessageVue severity="info" class="border-dashed border-300">
                      No se encontraron resultados.
                    </InlineMessageVue>

                  </template>

                  <template #loading>
                    <InlineMessageVue severity="info" class="border-dashed border-300">
                      Cargando....
                    </InlineMessageVue>
                  </template>
                  <ColumnVue v-for="col of columns" :field="col.field" :header="col.header" :key="col.field"
                    :sortable="true" :hidden="col.hidden" class="border-dashed border-300 tablaOficiosData">
                  </ColumnVue>
                   <ColumnVue :exportable="false" style="width: 250px;text-align: center;" header="Nombre Asistente" class="tablaOficiosData">
                    <template #body="slotProps">
                      <div>
                        <span class="">{{slotProps.data.nombre_asistente == '' ? 'N/A' : slotProps.data.nombre_asistente}}</span>
                      </div>
                    </template>
                  </ColumnVue>

                  <ColumnVue :exportable="false" style="width: 18rem" header="Opciones" class="tablaOficiosData">
                    <template #body="slotProps">

                      <!-- Oficios para CCP (Adjuntado)  -->
                      <SplitButtonVue 
                        icon="fa-solid fa-square-check fa-bounce" style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado16 w-full"
                        label="Opciones" v-tooltip.top="'Selecciona una opción'" :model="[

                          {
                            label: 'Ver oficio adjunto',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                              );
                            },
                          },

                    
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                         

                        ]" />
                      <!-- Oficios para CCP (Adjuntado)  -->

                     
                      <!-- Oficios para CCP (Creado)  -->

                    </template>
                  </ColumnVue>
                </DataTable>
              </div>

            </TabPanelVue>
          </TabViewVue>
        </div>
      </div>
      <!-- Tabs -->
      <Toast/>

    </div>
  </div>

  <!-- Oficios Pendientes -->
  <dialogVisualizarPDFBuzon v-if="hasRole('VisualizarPDF')" />
  <dialogContestarRemitente @valor="limpiarFilter" v-if="hasRole('ContestarOficioRemitente')" />
  <dialogContestarAtencion  @valor="limpiarFilter" v-if="hasRole('ContestarOficioAtencion')" />
  <dialogContestarAdjunto @valor="limpiarFilter" v-if="hasRole('ContestarAdjunto')" />
  <dialogContestarAdjuntoA @valor="limpiarFilter" v-if="hasRole('ContestarAdjuntoA')" />


  <!-- Oficios Pendientes -->
  <dialogFirmarPDF @valor="limpiarFilter" v-if="hasRole('FirmarPDF')" />
  <dialogFirmarAdjuntoPDF @valor="limpiarFilter" v-if="hasRole('AdjuntoFirmadoPDF')" />
  <dialogArchivarOficio @valor="limpiarFilter" v-if="hasRole('ArchivarOficio')"/>
  <dialogTurnarOficio @valor="limpiarFilter" v-if="hasRole('TurnarOficio')"/>
  <dialogVisualizarAcuse v-if="hasRole('VisualizarAcuse')" />

  <dialogAnadirAnexos v-if="hasRole('AnadirAnexos')" />
  <dialogModificarAnexos v-if="hasRole('ModificarAnexos')" />
  <dialogAsignarAsistente v-if="hasRole('AsignarAsistente')"/>
  <DialogVue v-model:visible="visibleBitacora" modal style="width: 60%;" pt:root:class="!border-0" pt:mask:class="backdrop-blur-sm">
    <template #container="{ closeCallback }">
      <div class="flex flex-column" style="background-color: white;position: relative;">
        <span @click="closeCallback" style="width: 100%; text-align:  right;font-size: 21px;top:8px; right: 18px; cursor:pointer; position: absolute;">X</span>

        <TabMenu class="m-0" v-model:activeIndex="tabVista" :model="items" />
        <div class="flex flex-row justify-content-center flex-wrap px-6  " style="height: 600px; border-radius: 12px; border-top-left-radius: 0; border-top-right-radius: 0;  overflow-y: scroll; background:white; position: relative">
          <h2 v-if="valueBitacora.length == 0" class="text-3xl text-gray-900">No hay movimientos</h2>
          <CardVue
          class="m-3"
          style="width:300px"
          v-for="(element, index) of valueBitacora"
          :key="element.usuario+index"
          >
          <template #title>Movimiento #{{ index+1 }}</template>
            <template #content>
              <ul>
                <li>Accion: <strong>{{element.accion}}</strong></li>
                <li>Fecha: <strong>{{element.fecha}}</strong></li>
                <li>Hora: <strong>{{element.hora}}</strong></li>
                <li>Usuario: <strong>{{element.usuario}}</strong></li>
              </ul>

            </template>
          </CardVue>
          <ButtonVue label="Cerrar" @click="closeCallback" text style="width:fit-content" class="!p-4 w-full !text-primary-50 !border !border-white/30 hover:!bg-white/10"></ButtonVue>

        </div>
      </div>
    </template>
  </DialogVue>
</template>

<script>
import { ref, onMounted, defineAsyncComponent } from 'vue';
import DataTable from "primevue/datatable";
import useOficiosRecepcion from "../composables/useOficiosRecepcion";
import useDialogVByCPP from '../composables/compDialogs/useDialogVByCCP';
import dialogAyudaRecepcionOficios from "../components/oficiosLibres/dialogAyudaRecepcionOficios";
import dialogDescargarAnexo from "../composables/compDialogs/useDialogDescargarAnexo";
import Swal from "sweetalert2";
import {  useRoute } from "vue-router";
import api from "@/api/laravelApi";
import useOficiosList from "../composables/useOficiosCreacion";
//Tabla Buzon
import useOpenDialogs from "../composables/useOpenDialogs";
import TabMenu from 'primevue/tabmenu';
//Tabla Buzon


export default {

  components: {
    //OficiosPendientes
    DataTable,TabMenu,
    dialogAyudaRecepcionOficios,
    dialogVisualizarPDFBuzon: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosCreados/dialogVisualizarPDF.vue")
    ),
    dialogContestarRemitente: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosRecepcion/dialogContestarRemitente")
    ),
    dialogContestarAtencion: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosRecepcion/dialogContestarAtencion")
    ),
    dialogContestarAdjunto: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosRecepcion/dialogContestarAdjunto")
    ),
    dialogContestarAdjuntoA: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosRecepcion/dialogContestarAdjunto")
    ),
    dialogFirmarPDF: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosCreados/dialogFirmarPDF.vue")
    ),
    dialogFirmarAdjuntoPDF: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosAdjuntos/dialogFirmarAdjuntoPDF.vue")
    ),
    dialogArchivarOficio: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosArchivados/dialogArchivarOficio.vue")
    ),
    dialogTurnarOficio: defineAsyncComponent(() =>
        import("../components/oficiosLibres/dialogTurnarOficio.vue")
    ),
    dialogVisualizarAcuse: defineAsyncComponent(() =>
    import("../components/oficiosLibres/oficiosCreados/dialogVisualizarAcuse.vue")
   ),
    //OficiosPendientes
    //Anexos
    dialogAnadirAnexos: defineAsyncComponent(() =>
      import("../components/oficiosLibres/dialogAnadirAnexos.vue")
    ),
    dialogModificarAnexos: defineAsyncComponent(() =>
      import("../components/oficiosLibres/dialogModificarAnexos.vue")
    ),
    dialogAsignarAsistente: defineAsyncComponent(() =>
      import("../components/oficiosLibres/dialogAsignarAsistente.vue")
    )

  },
  watch: {
    visibleBitacora(value) {
      if(value == false){
        this.tabVista = 0
      }
    }
  },

  setup() {
    /* const route = useRoute(); */
    /* const { code } = route.query; */
    const route = useRoute();
    const selectedTab = ref(route.params.tab);
    const selectedQuery = ref(route.query?.numero_oficio ?? '');
    
    console.log(route.params.tab, route)


    const {
          downloadAnexo
        } = dialogDescargarAnexo();


    const { descargarAnexos} = useOficiosList()


    const {
      openDialog,
      openDialogContestar,
      openDialogContestarA,
      openDialogMFicha,
      openDialogArchivar,
      openDialogTurnar,
      openDialogAnexar,
      openDialogAnexarModificar,
      openDialogAsignarAsistente,
      hasRole,
      toggleDialog,
    } = useOpenDialogs();

    const {
      columns,
      filtersCCP,
      filtersCCPAtencionOA,
      VoBoyCcp,
      getVoBoyCcp,
      contadorOficiosCCP,
      contadorOficiosCCPAlt,
      barraOficiosCCP,
      contadorOficiosOA,
      oficiosAtencionOA,
      getOficiosAtencionOA,
      filtersAtendidos,
    } = useDialogVByCPP();
  



    //Tabla de para consumir
    const {
      columnasPendientes,
      columnasAtencion,

      columnasArchivados,
      columnsVB,
      filtersPendientes,
      filtersAtencionA,
      filtersTurnados,

      filtersFirmados,
      filtersSalida,
      fichasRecepcionPendientes,
      fichasRecepcionAtencion,
      fichasRecepcionArchivados,

      fichasFirmadosR,

      getFichasFirmadasR,
      getFichasRecepcionPendientes,
      getFichasRecepcionAtencionA,

      contadorOficiosPendientes,
      contadorOficiosPendientesAlt,
      barraOficiosPendientes,

      contadorOficiosAtencion,
      contadorOficiosAtencionAlt,
      barraOficiosAtencion,


    

    } = useOficiosRecepcion();
    console.log(oficiosAtencionOA, fichasRecepcionPendientes, 'asdasd')


    const messages = ref([]);
    const count = ref(0);
    const addMessages = () => {
      messages.value = [
        {
          icon: 'pi pi-search',
          severity: 'info',
          content: 'Dynamic Info Message',
          id: count.value++
        },
      ]
    };

    const typeUser = Number(localStorage.getItem('typeUser'));

    const getFichasFirmadas = async () => {
      new Swal({
        title: "Cargando...",
        text: "Actualizando información de oficios firmados.",
        allowOutsideClick: false,
      });
      Swal.showLoading();
      const { ok, message } = await getFichasFirmadasR();
      if (!ok) Swal.fire("Error", message, "error");
      else {
        // window.dispatchEvent(new Event("cantidadOficiosRecepcion"));
        Swal.close();
      }

    }

    const getFichasRecepcionPendientesTabla = async () => {
      new Swal({
        title: "Cargando...",
        text: "Actualizando información de oficios pendientes.",
        allowOutsideClick: false,
      });
      Swal.showLoading();
      const { ok, message } = await getFichasRecepcionPendientes();
      if (!ok) Swal.fire("Error", message, "error");
      else {
        // window.dispatchEvent(new Event("cantidadOficiosRecepcion"));
        Swal.close();
      }

    }

    const getFichasRecepcionAtencionATabla = async () => {
      new Swal({
        title: "Cargando...",
        text: "Actualizando información de oficios de atencion.",
        allowOutsideClick: false,
      });
      Swal.showLoading();
      const { ok, message } = await getFichasRecepcionAtencionA();
      if (!ok) Swal.fire("Error", message, "error");
      else {
        // window.dispatchEvent(new Event("cantidadOficiosRecepcion"));
        Swal.close();
      }

    }

    const getFichasCCP = async () => {
      new Swal({
        title: "Cargando...",
        text: "Actualizando información de oficios de conococimiento.",
        allowOutsideClick: false,
      });
      Swal.showLoading();
      const { ok, message } = await getVoBoyCcp();
      if (!ok) Swal.fire("Error", message, "error");
      else {
        // window.dispatchEvent(new Event("cantidadOficiosRecepcion"));
        Swal.close();
      }

    }

    const getAll = async () => {
      await api.get('oficios/cantidadOficios').
      then((response) => {
            const dataNum = response.data.data
            localStorage.setItem("cantidadOficios", JSON.stringify(dataNum));

            // if (localStorage.getItem('cantidadOficios') !== null) {
              const data = JSON.parse(localStorage.getItem('cantidadOficios'));
              contadorOficiosPendientes.value = data.oficios_pendientes;
              contadorOficiosPendientesAlt.value = data.oficios_pendientes;
              contadorOficiosAtencion.value = data.oficios_atencion;
              contadorOficiosAtencionAlt.value = data.oficios_atencion;
              contadorOficiosCCP.value = data.oficios_ccp;
              contadorOficiosCCPAlt.value = data.oficios_ccp;
              contadorOficiosOA.value = data.oficios_observacion;
              console.log('asds')
            // }
          }
      ).catch(err => {
        // console.log(err)
        new Swal({
        title: "Error",
        text: err,
        allowOutsideClick: false,
        });
      })
    }

    onMounted(async () => {
      if (selectedQuery.value !== '') {
        if (route.params.tab == '0') {
          filtersPendientes.value.global.value = selectedQuery.value;
        } else if (route.params.tab == '1') {
          filtersAtencionA.value.global.value = selectedQuery.value;
        }
      }


      new Swal({
        title: "Cargando...",
        text: "Actualizando información del directorio de recepción de oficios",
        allowOutsideClick: false,
      });
      Swal.showLoading();
      // console.log("Mounted")

      await getVoBoyCcp();
      await getFichasRecepcionPendientes();
      await getFichasRecepcionAtencionA();
      await getOficiosAtencionOA()

      await barraOficiosPendientes();
      await barraOficiosAtencion();
      await barraOficiosCCP();
      


      window.addEventListener("cantidadOficiosRecepcion", getAll);
      Swal.close();
    });

    const limpiarFilter = () => {   
      filtersPendientes.value = {
        ...filtersPendientes.value,
        global: {value: '', matchMode: 'contains'}
      }
      filtersAtencionA.value = {
        ...filtersAtencionA.value,
        global: {value: '', matchMode: 'contains'}
      }
      filtersTurnados.value = {
        ...filtersTurnados.value,
        global: {value: '', matchMode: 'contains'}
      }
      filtersFirmados.value = {
        ...filtersFirmados.value,
        global: {value: '', matchMode: 'contains'}
      }
      filtersSalida.value = {
        ...filtersSalida.value,
        global: {value: '', matchMode: 'contains'}
      }
      filtersAtendidos.value = {
        ...filtersAtendidos.value,
        global: {value: '', matchMode: 'contains'}
      }

    }

    const visibleBitacora = ref(false);
    const valueBitacora = ref([]);
    const saveOficio = ref('');
    const tabVista = ref(0);

    const toggleBitacora = async(data, tab=1) => {
      Swal.showLoading();
      Swal.isLoading()
      visibleBitacora.value = true;
      saveOficio.value ={idOficio: data.idOficio}
      await api.get(`bitacora/${data.idOficio}/${tab}`)
      .then((response) => {
        valueBitacora.value = response.data.data.reverse();
        Swal.close()
      })
      .catch((error) => {
        // console.log(error)
        new Swal({
        title: "Error",
        text: error,
        allowOutsideClick: false,
        });
        Swal.close()
      })
    }
    const items = ref([
    {
      label: 'Movimientos de oficio',
      icon: 'pi pi-list',
      command: () => {
        toggleBitacora(saveOficio.value, 1)
      }
    },
    {
      label: 'Vistas de oficio',
      icon: 'pi pi-inbox',
      command: () => {
        toggleBitacora(saveOficio.value, 2)
      }
    },
]);

    return {
      limpiarFilter,
      selectedQuery,tabVista,items,

      visibleBitacora,
      toggleBitacora,
      valueBitacora,

      columnasPendientes,
      columnasAtencion,

      columnasArchivados,
      columnsVB,
      filtersPendientes,
      filtersAtencionA,
      filtersTurnados,
      filtersFirmados,

      filtersSalida,
      fichasRecepcionPendientes,
      fichasRecepcionArchivados,
      fichasRecepcionAtencion,

      fichasFirmadosR,
      addMessages,
      hasRole,
      openDialog,
      openDialogContestar,
      openDialogContestarA,
      openDialogArchivar,
      openDialogTurnar,
      openDialogAnexar,
      openDialogAnexarModificar,
      openDialogAsignarAsistente,
      toggleDialog,
      dialogAyudaRecepcionOficios,
      openDialogMFicha,

      getFichasFirmadas,
      getFichasRecepcionPendientesTabla,
      getFichasRecepcionAtencionATabla,

      columns,
      filtersCCP,
      VoBoyCcp,
      getFichasCCP,
      downloadAnexo,

      contadorOficiosPendientes,
      contadorOficiosPendientesAlt,
      barraOficiosPendientes,

      contadorOficiosAtencion,
      contadorOficiosAtencionAlt,
      barraOficiosAtencion,

      contadorOficiosCCP,
      contadorOficiosCCPAlt,
      barraOficiosCCP,
      selectedTab,
      typeUser,
      descargarAnexos,
      contadorOficiosOA,
      oficiosAtencionOA,
      filtersCCPAtencionOA,
      filtersAtendidos,
    }
  },

}
</script>

<style scoped lang="scss">

::v-deep(.titulosPestanasContador){
  font-size: 9px;
  background-color: rgb(18, 95, 168);
  // background-color: #bec3c9;
}

.coloraux1 {
  background: #4a001f;
  font-size: 13px;
  font-weight: lighter;
}

.coloraux2 {
  background: #919191;
  font-size: 12px;
  font-weight: lighter;
}

.buttonAbrirOficio {
  background-color: #4a001f;
}

::v-deep(.cardEntrada) {
  background-color: rgb(185, 185, 185);

  .p-card-title {
    font-size: 14px;
  }

  .p-card-content {
    font-size: 12px;
  }
}

.titleaccordion {
  font-size: 13px
}

::v-deep(.columnasOcultas) {
  font-size: 1px;
  padding-bottom: 1px;
  display: block;
  color: red;

  .p-datatable-thead {
    color: red;
    display: block;
  }
}

::v-deep(.botonAyuda) {
  .p-button-icon {
    font-size: 25px;
    transition: ease 1s;
  }
}

::v-deep(.botonAyuda:hover) {
  .p-button-icon {
    font-size: 25px;
    color: rgb(77, 77, 77);
    transition: ease 1s;
  }
}


@media only screen and (max-width: 600px) {

  .tablaTitle {
    font-size: 15px;
    transition: ease 1s;
  }

  .titulosPestanas {
    height: 55px;
    width: 65px;
    transition: ease 1s;
  }

  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 15px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 15px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 10px;
    transition: ease 1s;

    .p-column-title {
      font-size: 12px
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 10.5px;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7E51F5 !important;
      border-color: #7E51F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #5b3caf !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #406BD6 !important;
      border-color: #406BD6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #274181 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado9) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4ED1EB !important;
      border-color: #4ED1EB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado9:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #388a9b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #C2A9F5 !important;
      border-color: #C2A9F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #685a83 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado11) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #8D9ED6 !important;
      border-color: #8D9ED6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado11:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #8D9ED6 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7A) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #5BB7F5 !important;
      border-color: #5BB7F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7A:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #3d759b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8A) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #49D6C0 !important;
      border-color: #49D6C0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8A:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #31867a !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado9A) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #48c267 !important;
      border-color: #48c267 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado9A:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #37924e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7dafc9 !important;
      border-color: #7dafc9 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7297aa !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado11) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #72aa9d !important;
      border-color: #72aa9d !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado11:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #65a193 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado12) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6a9171 !important;
      border-color: #6a9171 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado12:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #68a172 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #9ac26c !important;
      border-color: #9ac26c !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #89ad60 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13A) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #8ED63C !important;
      border-color: #8ED63C !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13A:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6ca031 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13T) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6BA32D !important;
      border-color: #6BA32D !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13T:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4a701e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10T) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6899b1 !important;
      border-color: #6899b1 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10T:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #395461 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7C) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4A6CF0 !important;
      border-color: #4A6CF0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7C:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #364da8 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7A) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4596F7 !important;
      border-color: #4596F7 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7A:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4596F7 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7T) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4BB3E0 !important;
      border-color: #4BB3E0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7T:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4BB3E0 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15){
  .p-component{
    font-size: 8px !important;
    height: 35px !important;
    max-height: 35px !important;

    background-color: #393939 !important;
    border-color: #393939  !important;
    transition: ease 1s;

  }
}

::v-deep(.splitRecepcionEstado15:hover){
  .p-component{
    font-size: 8px !important;
    height: 35px !important;
    max-height: 35px !important;

    background-color: #131313  !important;
    border-color: #ffffff !important;
    border-style: dotted;
    transition: ease 1s;
  }
}

}

@media only screen and (min-width: 600px) {

  .tablaTitle {
    font-size: 18px;
    transition: ease 1s;
  }

  .titulosPestanas {
    height: 55px;
    width: 85px;
    transition: ease 1s;
  }

  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 18px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 18px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 12px;
    transition: ease 1s;

    .p-column-title {
      font-size: 13px
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 11px;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7E51F5 !important;
      border-color: #7E51F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #5b3caf !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #406BD6 !important;
      border-color: #406BD6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #274181 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado9) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4ED1EB !important;
      border-color: #4ED1EB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado9:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #388a9b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #C2A9F5 !important;
      border-color: #C2A9F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #685a83 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado11) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #8D9ED6 !important;
      border-color: #8D9ED6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado11:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #8D9ED6 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7A) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #5BB7F5 !important;
      border-color: #5BB7F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7A:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #3d759b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8A) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #49D6C0 !important;
      border-color: #49D6C0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8A:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #31867a !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado9A) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #48c267 !important;
      border-color: #48c267 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado9A:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #37924e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7dafc9 !important;
      border-color: #7dafc9 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7297aa !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado11) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #72aa9d !important;
      border-color: #72aa9d !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado11:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #65a193 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado12) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6a9171 !important;
      border-color: #6a9171 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado12:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #68a172 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #9ac26c !important;
      border-color: #9ac26c !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #89ad60 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13A) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #8ED63C !important;
      border-color: #8ED63C !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13A:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6ca031 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13T) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6BA32D !important;
      border-color: #6BA32D !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13T:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4a701e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10T) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6899b1 !important;
      border-color: #6899b1 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10T:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #395461 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7C) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4A6CF0 !important;
      border-color: #4A6CF0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7C:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #364da8 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7A) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4596F7 !important;
      border-color: #4596F7 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7A:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4596F7 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7T) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4BB3E0 !important;
      border-color: #4BB3E0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7T:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4BB3E0 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15){
  .p-component{
    font-size: 10px !important;
    height: 35px !important;
    max-height: 35px !important;

    background-color: #393939 !important;
    border-color: #393939  !important;
    transition: ease 1s;

  }
}

::v-deep(.splitRecepcionEstado15:hover){
  .p-component{
    font-size: 10px !important;
    height: 35px !important;
    max-height: 35px !important;

    background-color: #131313  !important;
    border-color: #ffffff !important;
    border-style: dotted;
    transition: ease 1s;
  }
}

}

@media only screen and (min-width: 768px) {

  .tablaTitle {
    font-size: 14px;
    transition: ease 1s;
  }

  .titulosPestanas {
    height: 55px;
    width: 125px;
    transition: ease 1s;
  }

  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 20px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 20px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 12px;
    transition: ease 1s;

    .p-column-title {
      font-size: 13px
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 12px;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7E51F5 !important;
      border-color: #7E51F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #5b3caf !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #406BD6 !important;
      border-color: #406BD6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #274181 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado9) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4ED1EB !important;
      border-color: #4ED1EB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado9:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #388a9b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #C2A9F5 !important;
      border-color: #C2A9F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #685a83 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado11) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #8D9ED6 !important;
      border-color: #8D9ED6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado11:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #8D9ED6 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7A) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #5BB7F5 !important;
      border-color: #5BB7F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7A:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #3d759b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8A) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #49D6C0 !important;
      border-color: #49D6C0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8A:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #31867a !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado9A) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #48c267 !important;
      border-color: #48c267 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado9A:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #37924e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7dafc9 !important;
      border-color: #7dafc9 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7297aa !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado11) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #72aa9d !important;
      border-color: #72aa9d !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado11:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #65a193 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado12) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6a9171 !important;
      border-color: #6a9171 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado12:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #68a172 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #9ac26c !important;
      border-color: #9ac26c !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #89ad60 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13A) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #8ED63C !important;
      border-color: #8ED63C !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13A:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6ca031 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13T) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6BA32D !important;
      border-color: #6BA32D !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13T:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4a701e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10T) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6899b1 !important;
      border-color: #6899b1 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10T:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #395461 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7C) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4A6CF0 !important;
      border-color: #4A6CF0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7C:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #364da8 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7A) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4596F7 !important;
      border-color: #4596F7 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7A:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4596F7 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7T) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4BB3E0 !important;
      border-color: #4BB3E0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7T:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4BB3E0 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15){
  .p-component{
    font-size: 10px !important;
    height: 35px !important;
    max-height: 35px !important;

    background-color: #393939 !important;
    border-color: #393939  !important;
    transition: ease 1s;

  }
}

::v-deep(.splitRecepcionEstado15:hover){
  .p-component{
    font-size: 10px !important;
    height: 35px !important;
    max-height: 35px !important;

    background-color: #131313  !important;
    border-color: #ffffff !important;
    border-style: dotted;
    transition: ease 1s;
  }
}

}

@media only screen and (min-width: 992px) {

  .tablaTitle {
    font-size: 16px;
    transition: ease 1s;
  }

  .titulosPestanas {
    height: 35px;
    width: 155px;
    transition: ease 1s;
  }

  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 21px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 21px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 13px;
    transition: ease 1s;

    .p-column-title {
      font-size: 13px
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 11px;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7E51F5 !important;
      border-color: #7E51F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #5b3caf !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #406BD6 !important;
      border-color: #406BD6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #274181 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado9) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4ED1EB !important;
      border-color: #4ED1EB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado9:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #388a9b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #C2A9F5 !important;
      border-color: #C2A9F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #685a83 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado11) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #8D9ED6 !important;
      border-color: #8D9ED6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado11:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #8D9ED6 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7A) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #5BB7F5 !important;
      border-color: #5BB7F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7A:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #3d759b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8A) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #49D6C0 !important;
      border-color: #49D6C0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8A:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #31867a !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado9A) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #48c267 !important;
      border-color: #48c267 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado9A:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #37924e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7dafc9 !important;
      border-color: #7dafc9 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7297aa !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado11) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #72aa9d !important;
      border-color: #72aa9d !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado11:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #65a193 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado12) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6a9171 !important;
      border-color: #6a9171 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado12:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #68a172 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #9ac26c !important;
      border-color: #9ac26c !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #89ad60 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13A) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #8ED63C !important;
      border-color: #8ED63C !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13A:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6ca031 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13T) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6BA32D !important;
      border-color: #6BA32D !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13T:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4a701e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10T) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6899b1 !important;
      border-color: #6899b1 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10T:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #395461 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7C) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4A6CF0 !important;
      border-color: #4A6CF0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7C:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #364da8 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7A) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4596F7 !important;
      border-color: #4596F7 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7A:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4596F7 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7T) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4BB3E0 !important;
      border-color: #4BB3E0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7T:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4BB3E0 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15){
  .p-component{
    font-size: 10px !important;
    height: 35px !important;
    max-height: 35px !important;

    background-color: #393939 !important;
    border-color: #393939  !important;
    transition: ease 1s;

  }
}

::v-deep(.splitRecepcionEstado15:hover){
  .p-component{
    font-size: 10px !important;
    height: 35px !important;
    max-height: 35px !important;

    background-color: #131313  !important;
    border-color: #ffffff !important;
    border-style: dotted;
    transition: ease 1s;
  }
}


}

@media only screen and (min-width: 1200px) {


  .tablaTitle {
    font-size: 20px;
    transition: ease 1s;
  }

  .titulosPestanas {
    height: 50px;
    width: 180px;
    transition: ease 1s;
  }

  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 22px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 22px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 16px;
    transition: ease 1s;

    .p-column-title {
      font-size: 16px
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 14px;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #7E51F5 !important;
      border-color: #7E51F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #5b3caf !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #406BD6 !important;
      border-color: #406BD6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #274181 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado9) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #4ED1EB !important;
      border-color: #4ED1EB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado9:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #388a9b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #C2A9F5 !important;
      border-color: #C2A9F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #685a83 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado11) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #8D9ED6 !important;
      border-color: #8D9ED6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado11:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #8D9ED6 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7A) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #5BB7F5 !important;
      border-color: #5BB7F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7A:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #3d759b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8A) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #49D6C0 !important;
      border-color: #49D6C0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8A:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #31867a !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado9A) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #48c267 !important;
      border-color: #48c267 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado9A:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #37924e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #7dafc9 !important;
      border-color: #7dafc9 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #7297aa !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado11) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #72aa9d !important;
      border-color: #72aa9d !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado11:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #65a193 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado12) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #6a9171 !important;
      border-color: #6a9171 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado12:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #68a172 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #9ac26c !important;
      border-color: #9ac26c !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #89ad60 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13A) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #8ED63C !important;
      border-color: #8ED63C !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13A:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #6ca031 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13T) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #6BA32D !important;
      border-color: #6BA32D !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13T:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #4a701e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado5:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #215e06 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10T) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #6899b1 !important;
      border-color: #6899b1 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10T:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #395461 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7C) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #4A6CF0 !important;
      border-color: #4A6CF0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7C:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #364da8 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7A) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #4596F7 !important;
      border-color: #4596F7 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7A:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #4596F7 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7T) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #4BB3E0 !important;
      border-color: #4BB3E0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7T:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #4BB3E0 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15){
  .p-component{
    font-size: 15px !important;
    height: 50px !important;
    max-height: 50px !important;

    background-color: #393939 !important;
    border-color: #393939  !important;
    transition: ease 1s;

  }
}

::v-deep(.splitRecepcionEstado15:hover){
  .p-component{
    font-size: 15px !important;
    height: 50px !important;
    max-height: 50px !important;

    background-color: #131313  !important;
    border-color: #ffffff !important;
    border-style: dotted;
    transition: ease 1s;
  }
}


}

@media only screen and (min-width: 1515px) {

  .tablaTitle {
    font-size: 20px;
    transition: ease 1s;
  }

  .titulosPestanas {
    height: 40px;
    width: 175px;
    transition: ease 1s;
  }

  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 25px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 25px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 13px;
    transition: ease 1s;

    .p-column-title {
      font-size: 13px
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 13px;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #7E51F5 !important;
      border-color: #7E51F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #5b3caf !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #406BD6 !important;
      border-color: #406BD6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #274181 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado9) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #4ED1EB !important;
      border-color: #4ED1EB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado9:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #388a9b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #C2A9F5 !important;
      border-color: #C2A9F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #685a83 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado11) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #8D9ED6 !important;
      border-color: #8D9ED6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado11:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #8D9ED6 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7A) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #5BB7F5 !important;
      border-color: #5BB7F5 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7A:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #3d759b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8A) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #49D6C0 !important;
      border-color: #49D6C0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8A:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #31867a !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado9A) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #48c267 !important;
      border-color: #48c267 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado9A:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #37924e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #7dafc9 !important;
      border-color: #7dafc9 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #7297aa !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado11) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #72aa9d !important;
      border-color: #72aa9d !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado11:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #65a193 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado12) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #6a9171 !important;
      border-color: #6a9171 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado12:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #68a172 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #9ac26c !important;
      border-color: #9ac26c !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #89ad60 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13A) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #8ED63C !important;
      border-color: #8ED63C !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13A:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #6ca031 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado13T) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #6BA32D !important;
      border-color: #6BA32D !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado13T:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #4a701e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado10T) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #6899b1 !important;
      border-color: #6899b1 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado10T:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #395461 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7C) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #4A6CF0 !important;
      border-color: #4A6CF0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7C:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #364da8 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7A) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #4596F7 !important;
      border-color: #4596F7 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7A:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #4596F7 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado7T) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #4BB3E0 !important;
      border-color: #4BB3E0 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado7T:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #4BB3E0 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15){
  .p-component{
    font-size: 13px !important;
    height: 35px !important;
    max-height: 35px !important;

    background-color: #393939 !important;
    border-color: #393939  !important;
    transition: ease 1s;

  }
}

::v-deep(.splitRecepcionEstado15:hover){
  .p-component{
    font-size: 8px !important;
    height: 35px !important;
    max-height: 35px !important;

    background-color: #131313  !important;
    border-color: #ffffff !important;
    border-style: dotted;
    transition: ease 1s;
  }
}

}
</style>
